const SCRIPT_ID = 'recaptcha-script';

const getSiteKey = (): string | undefined =>
  process.env.REACT_APP_RECAPTCHA_SITE_KEY?.trim() || undefined;

export const isRecaptchaEnabled = (): boolean => Boolean(getSiteKey());

export function loadRecaptchaScript(): Promise<void> {
  const siteKey = getSiteKey();
  if (!siteKey) {
    return Promise.resolve();
  }

  if (window.grecaptcha?.execute) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (existing) {
      if (window.grecaptcha?.execute) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), {once: true});
      existing.addEventListener('error', () => reject(new Error('Failed to load reCAPTCHA')), {once: true});
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.head.appendChild(script);
  });
}

/** SCORE key (site + secret): token for siteverify on the backend. */
export async function executeRecaptcha(action: string): Promise<string | null> {
  const siteKey = getSiteKey();
  if (!siteKey) {
    return null;
  }

  await loadRecaptchaScript();

  const grecaptcha = window.grecaptcha;
  if (!grecaptcha) {
    throw new Error('reCAPTCHA is not available');
  }

  return new Promise((resolve, reject) => {
    grecaptcha.ready(() => {
      grecaptcha
        .execute(siteKey, {action})
        .then(resolve)
        .catch(reject);
    });
  });
}
